import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

import { ref, reactive, computed } from 'vue'
import CmTable from '@/components/cmTable/index.vue'
import CmForm from '@/components/cmForm/index.vue'
import { FormActionType, FormSize, FormSizeType } from '@/components/cmForm/types'
import { WhiteListType } from '../types'
import Card from '../../_components/card/card.vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'whitelist-section',
  props: {
    type: {},
    title: {},
    table_title: {},
    count: {},
    data: {},
    queryForm: {}
  },
  emits: ["update:queryForm", "add", "batchRemove", "remove", "changeSelected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()

const props = __props

const emit = __emit

const formType = FormActionType.Other
const formSize: FormSizeType = FormSize.Small
const tableRef = ref()
const selectedIds = ref<any[]>([])
const multiple = ref(false)
const queryFormDisabled = ref(false)
const loading = ref(false)

const localQueryForm = computed({
  get: () => props.queryForm,
  set: (val) => emit('update:queryForm', val)
})

const filterList = computed(() => {
  if (localQueryForm.value.file_name) {
    return props.data?.filter?.(item => item.value.includes(localQueryForm.value.file_name)) || []
  }
  return props.data || []
})

const queryFormColumns = reactive({
  file_name: {
    label: props.title,
    colOpt: { style: "flex: 0 0 auto; width: 360px" },
    hiddenAllLabel: true,
    placeholder: props.title,
    modelModifiers: { trim: true },
    inputOpt: {
      'suffix-icon': 'el-icon-search',
    },
  }
})

const tableActOpt = computed(() => {
  void locale.value
  return {
    columnOpt: { label: t('fileWhitelistSection.operation'), width: 80, align: 'left', fixed: 'right' },
    actionButtons: (row: any) => [
      {
        name: t('fileWhitelistSection.remove'),
        type: 'remove',
        opt: { size: FormSize.Small, type: 'text' },
        events: {
          click: () => {
            emit('remove', row)
          }
        }
      },
    ],
  }
})

const tableOpt = computed(() => {
  void locale.value
  return {
    hiddenPageTool: true,
    'max-height': '600px',
    bodyStyle: 'flex:1;padding:0;',
    actionBarRowOptStyle: { 'margin-bottom': '0' },
    containerOpt: { style: 'padding: 0;margin-top: 0;background: var(--cm-color-card-bg);' },
    showActionBar: true,
    showForm: false,
    showTip: false,
    showRightToolbar: false,
    path: 'data',
    rowKey: 'index',
    selection: true,
    columns: [
      { label: props.table_title, prop: 'value', showOverflow: true },
      { label: t('fileWhitelistSection.remark'), prop: 'comment',  showOverflow: true },
      { label: t('fileWhitelistSection.updateBy'), prop: 'update_by',  showOverflow: true },
      { label: t('fileWhitelistSection.updateTime'), prop: 'update_time', showOverflow: true },
    ],
  }
})

function handleAdd() {
  emit('add')
}

function handleBatchRemove() {
  emit('batchRemove')
}

function handleChangeSelected(selectedRows: any[], idArray: any[]) {
  selectedIds.value = idArray
  multiple.value = true
  emit('changeSelected', idArray)
}

/** 提交成功后清空表格多选与父级 ids */
function clearTableSelection() {
  tableRef.value?.tableRef?.clearSelection?.()
  selectedIds.value = []
  emit('changeSelected', [])
}

__expose({
  tableRef,
  clearTableSelection,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    "is-border": "",
    title: _ctx.title
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { justify: "space-between" }, {
        default: _withCtx(() => [
          _createVNode(CmForm, {
            formSize: _unref(formSize),
            formType: _unref(formType),
            "onUpdate:formType": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formType) ? (formType).value = $event : null)),
            crossorigin: "anonymous",
            class: "search-form",
            actionColOpt: { style: 'display:flex;justify-content:flex-start' },
            rowOpt: { style: 'justify-content: flex-end' },
            disabled: queryFormDisabled.value,
            "onUpdate:disabled": _cache[1] || (_cache[1] = ($event: any) => ((queryFormDisabled).value = $event)),
            modelValue: localQueryForm.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localQueryForm).value = $event)),
            formColumns: queryFormColumns
          }, null, 8, ["formSize", "formType", "disabled", "modelValue", "formColumns"]),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-left":"auto"},
            size: "small",
            onClick: handleAdd
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('safeProtectionModule.add')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            disabled: !selectedIds.value.length || !multiple.value,
            onClick: handleBatchRemove
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('safeProtectionModule.batchRemove')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(CmTable, {
          tableOpt: tableOpt.value,
          onChangeSelected: handleChangeSelected,
          tableActOpt: tableActOpt.value,
          data: filterList.value,
          "onUpdate:data": _cache[3] || (_cache[3] = ($event: any) => ((filterList).value = $event)),
          disabled: queryFormDisabled.value,
          "first-loading": false,
          "has-permission": true,
          ref_key: "tableRef",
          ref: tableRef
        }, null, 8, ["tableOpt", "tableActOpt", "data", "disabled"])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})